import { useState } from 'react';
import { Flex, Button, TextField, Text } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';
import { IconPicker } from './IconPicker.jsx';
import styles from './manage_categories.module.css';

export const CategoryForm = ({
  category = null,
  onSave,
  onCancel,
  isSubmitting,
}) => {
  const { t } = useTranslation('vault');

  const [name, setName] = useState(category?.name || '');
  const [icon, setIcon] = useState(category?.icon || 'fa-folder');

  const handleSave = () => {
    if (!name.trim()) return;
    onSave({ name: name.trim(), icon });
  };

  return (
    <Flex direction="column" gap="4">
      <Flex direction="column" gap="1">
        <Text as="label" size="2" weight="medium">
          {t('categoryName')}
        </Text>
        <Flex gap="3" align="center">
          <div className={styles.categoryIcon}>
            <i className={`fa-regular ${icon}`} />
          </div>
          <TextField.Root
            size="3"
            value={name}
            onChange={e => setName(e.target.value)}
            placeholder={t('categoryName')}
            style={{ flex: 1 }}
            onKeyDown={e => {
              if (e.key === 'Enter' && name.trim()) handleSave();
            }}
            autoFocus
          />
        </Flex>
      </Flex>

      <Flex direction="column" gap="1">
        <Text as="label" size="2" weight="medium">
          {t('selectIcon')}
        </Text>
        <IconPicker selectedIcon={icon} onSelectIcon={setIcon} />
      </Flex>

      <Flex gap="3" mt="2" justify="end">
        <Button size="3" variant="outline" onClick={onCancel}>
          {t('cancel')}
        </Button>
        <Button
          size="3"
          variant="solid"
          onClick={handleSave}
          disabled={!name.trim() || isSubmitting}
        >
          {t('save')}
        </Button>
      </Flex>
    </Flex>
  );
};
